var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toast-container"},_vm._l((_vm.notifications),function(item,index){return _c('Notification',{key:index,attrs:{"animated":true,"type":item.type,"title":item.title,"message":item.message,"duration":item.duration}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }